import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { SessionStorageService } from '../services/session-storage.service';
import { tokenEstaExpirado } from '../core/utils/token.util';

const MENSAGEM_BLOQUEIO_PADRAO =
  'Acesso temporariamente indisponível para esta empresa. Entre em contato com o suporte Kali.';

// Token cuja sessão já foi encerrada por bloqueio (403-10); evita avisos repetidos
// quando várias respostas simultâneas chegam com o mesmo token.
let tokenBloqueadoAvisado: string | null = null;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const sessionStorageService = inject(SessionStorageService);
  const toastr = inject(ToastrService);
  const token = sessionStorageService.getToken();

  // Novo login (token diferente ou ausente) reinicia a guarda
  if (tokenBloqueadoAvisado !== null && token !== tokenBloqueadoAvisado) {
    tokenBloqueadoAvisado = null;
  }

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && (!token || tokenEstaExpirado(token))) {
        sessionStorageService.clearSession();
        router.navigate(['/login']);
      }
      if (error.status === 403 && error.error?.code === '403-10' && token && tokenBloqueadoAvisado !== token) {
        tokenBloqueadoAvisado = token;
        toastr.error(error.error.message || MENSAGEM_BLOQUEIO_PADRAO);
        sessionStorageService.clearSession();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
